import { Component } from '@angular/core';
import { Overlay } from "./../commonMap/overlay";

@Component({
    moduleId: module.id,
    selector: 's1dbg-s1dbm01',
    templateUrl: './s1dbg-s1dbm01.component.html'
})
export class S1dbgS1dbm01Component extends Overlay {
    dbmsg1: any = {};

    public FIELDS: string[] = ['dbmsg1'];
    public LINES: number[] = [1];

    ngAfterViewInit(): void {
    }
}
